<template>
	<div class="print">
		<MainColumn class="center">
			<Logo />
			{{$store.state.text}}
		</MainColumn>
	</div>
</template>

<script>
import MainColumn from '@/components/MainColumn.vue';
import Logo from '@/components/Logo.vue';

export default {
	components: {
		MainColumn,
		Logo
	},
	mounted(){
		window.print();
	}
}
</script>
<style scoped lang="scss">
	
</style>